import {
  CLEAR_PARCEL,
  GET_PARCEL_FAILURE,
  GET_PARCEL_REQUEST,
  GET_PARCEL_SUCCESS,
} from "data/constants"

const defaultState = {
  state: "INITIAL",
  error: null,
  data: null,
}

export default function parcel(state = defaultState, action) {
  switch (action.type) {
    case GET_PARCEL_REQUEST:
      return {
        ...state,
        state: "LOADING",
        error: null,
        data: null,
      }
    case GET_PARCEL_SUCCESS:
      return {
        ...state,
        state: "LOADED",
        data: action.data,
        error: null,
      }
    case GET_PARCEL_FAILURE:
      return {
        ...state,
        state: "FAILED",
        error: action.error,
        data: null,
      }
    case CLEAR_PARCEL:
      return defaultState
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/data/reducers/parcel.js